export { PriceComparisonTableContainer as PriceComparisonTable } from './PriceComparisonTableContainer'
export const priceComparisonTableToken = 'priceComparisonTable'
